import { jsx as _jsx } from "react/jsx-runtime";
// -------------------------------------------------------
// NOTE: This is a generated file, do not manually modify!
// -------------------------------------------------------
import { SvgIcon } from '@mui/material';
const paths = [
    'M7.80082 9.66243L5.0826 6.90203C4.97247 6.7919 4.97247 6.61381 5.0826 6.50367L5.24898 6.3373C5.35911 6.22717 5.5372 6.22717 5.64733 6.3373L8 8.73449L10.3527 6.33964C10.4628 6.22951 10.6409 6.22951 10.751 6.33964L10.9174 6.50602C11.0275 6.61615 11.0275 6.79424 10.9174 6.90438L8.19918 9.66478C8.08904 9.77257 7.91095 9.77257 7.80082 9.66243Z',
];
export const AngleBottom = (props) => (_jsx(SvgIcon, Object.assign({ viewBox: "0 0 16 16" }, props, { children: paths.map((pathString, i) => (_jsx("path", { d: pathString }, i))) })));
AngleBottom.iconCategory = 'ui';
